<template>
  <div class="block">
    <div class="block-title header">
      <div class="title">商品推广列表</div>
    </div>
    <goods-list></goods-list>
  </div>
</template>

<script>
import List from './components/list.vue'
import GoodsList from "./components/goodsList.vue";
export default {
  components:{
    GoodsList,
    List
  }
}
</script>

<style scoped lang="less">
.header{
  display: flex;
  justify-content: space-between;
  .title{
    font-size: 18px;
    font-weight: 700;
    color: #333;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/pc/douyin/poiDistribution/goods.vue